module.exports = __webpack_public_path__ + "static/img/logo_10.3621f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_10.png
// module id = zEWP
// module chunks = 1